import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalImageLoaderComponent } from './local-image-loader/local-image-loader.component';
import { HttpImageLoaderComponent } from './http-image-loader/http-image-loader.component';

@NgModule({
  declarations: [LocalImageLoaderComponent, HttpImageLoaderComponent],
  imports: [CommonModule],
  providers: [],
  exports: [LocalImageLoaderComponent, HttpImageLoaderComponent],
})
export class ImageStoreModule {}
